// @flow
import { getStateCurrentValue, getStateIsFilterActive, type State } from 'app/common/ui-components/filter';

import { filterId } from './filterId';


export const filterActive = (state: State): boolean => {
  return getStateIsFilterActive(filterId, state);
};

export const singleClassSelected = (state: State) => {
  const classIds = getStateCurrentValue(filterId, state);
  return classIds.length === 1;
};
